

























import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  HonorAction,
  HonorActionType,
  IHonorAction,
} from '../../store/profile/types';

@Component({})
export default class GalaHonorAction extends Vue {
  @Prop(Object) readonly action!: IHonorAction;

  actionData: Record<HonorActionType, { icon: string; color: string }> = {
    [HonorActionType.BAD]: { icon: 'mdi-arrow-bottom-right', color: '#FF78DD' },
    [HonorActionType.GOOD]: { icon: 'mdi-arrow-top-right', color: '#7AFFEF' },
    [HonorActionType.REDEEMING]: {
      icon: 'mdi-shield-check-outline',
      color: 'white',
    },
  };

  getActionText(action: HonorAction) {
    switch (action) {
      case HonorAction.BRIDGE_CURRENCY_TO_ETH:
        return this.$t('pages.galaHonor.bridgeCurrencyToEthDescription', {
          currency: 'SILK',
        });
      case HonorAction.BRIDGE_CURRENCY_TO_GYRI:
        return this.$t('pages.galaHonor.bridgeCurrencyToGyriDescription', {
          currency: 'SILK',
        });
      case HonorAction.TRANSFER_CURRENCY:
        return this.$t('pages.galaHonor.transferCurrencyDescription', {
          currency: 'SILK',
        });
      case HonorAction.PLAY_AND_EARN:
        return this.$t('pages.galaHonor.playAndEarnDescription');
      case HonorAction.RUN_NODE:
        return this.$t('pages.galaHonor.runNodeDescription');
      case HonorAction.PURCHASE:
        return this.$t('pages.galaHonor.purchaseDescription', {
          currency: 'SILK[ETH]',
        });
    }
  }

  getDate(timestamp: Date) {
    return new Date(timestamp).toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
}
